import predatorBadlands from "../assets/series/predator-badlands.webp";
import thursdayMurderClub from "../assets/series/thursday-murder-club.webp";
import conjuringLastRites from "../assets/series/conjuring-last-rites.webp";
import mortalKombat2 from "../assets/series/mortal-kombat-2.webp";
import avatarFireAndAsh from "../assets/series/avatar-fire-and-ash.webp";
import wakeUpDeadMan from "../assets/series/wake-up-dead-man.webp";
import swiped from "../assets/series/swiped.webp";
import trasElVerano from "../assets/series/tras-el-verano.webp";
import anaconda from "../assets/series/anaconda.webp";
import theOdyssey from "../assets/series/the-odyssey.webp";
import zootopia2 from "../assets/series/zootopia-2.webp";
import manhunt from "../assets/series/manhunt.webp";

import chn1 from "../assets/channel/Apple_TV.svg";
import chn2 from "../assets/channel/Antena_3.svg";
import chn3 from "../assets/channel/BeIN_Sports.svg";
import chn4 from "../assets/channel/Movistar_Plus.svg";
import chn5 from "../assets/channel/DAZN.svg";
import chn6 from "../assets/channel/Disney_Plus.svg";
import chn7 from "../assets/channel/HBO_Max.svg";
import chn8 from "../assets/channel/Hulu.svg";
import chn9 from "../assets/channel/Telecinco.svg";
import chn10 from "../assets/channel/Netflix.svg";
import chn11 from "../assets/channel/Cuatro.svg";
import chn12 from "../assets/channel/Pluto_TV.svg";
import chn13 from "../assets/channel/Prime_Video.svg";
import chn14 from "../assets/channel/RTVE.svg";
import chn15 from "../assets/channel/LaSexta.svg";
import chn16 from "../assets/channel/SkyShowtime.svg";
import chn17 from "../assets/channel/Paramount_Plus.svg";
import chn18 from "../assets/channel/Rakuten_TV.svg";

import SectionHeading from '../components/SectionHeading';
import Marquee from '../components/Marquee';
import Reveal from '../components/Reveal';
import { useLanguage } from '../i18n/LanguageContext';
import { filmContent } from '../i18n/content/film';

export default function Film() {
  const { lang } = useLanguage();
  const c = filmContent[lang];
  const films = [
    { image: predatorBadlands, name: "Predator: Badlands" },
    { image: thursdayMurderClub, name: "The Thursday Murder Club" },
    { image: conjuringLastRites, name: "The Conjuring: Last Rites" },
    { image: mortalKombat2, name: "Mortal Kombat II" },
    { image: avatarFireAndAsh, name: "Avatar: Fire and Ash" },
    { image: wakeUpDeadMan, name: "Wake Up Dead Man" },
  ].map((film, i) => ({ id: i, ...film }));

  const series = [
    { image: swiped, name: "Swiped" },
    { image: trasElVerano, name: "Tras el Verano" },
    { image: anaconda, name: "Anaconda" },
    { image: theOdyssey, name: "The Odyssey" },
    { image: zootopia2, name: "Zootopia 2" },
    { image: manhunt, name: "Manhunt" },
  ].map((show, i) => ({ id: i, ...show }));

  const channels = [
    { id: 1, image: chn5, name: "DAZN" },
    { id: 2, image: chn10, name: "Netflix" },
    { id: 3, image: chn13, name: "Prime Video" },
    { id: 4, image: chn6, name: "Disney+" },
    { id: 5, image: chn4, name: "Movistar Plus+" },
    { id: 6, image: chn3, name: "beIN SPORTS" },
    { id: 7, image: chn2, name: "Antena 3" },
    { id: 8, image: chn7, name: "HBO Max" },
    { id: 9, image: chn9, name: "Telecinco" },
    { id: 10, image: chn11, name: "Cuatro" },
    { id: 11, image: chn12, name: "Pluto TV" },
    { id: 12, image: chn1, name: "Apple TV+" },
    { id: 13, image: chn14, name: "RTVE" },
    { id: 14, image: chn15, name: "La Sexta" },
    { id: 15, image: chn16, name: "SkyShowtime" },
    { id: 16, image: chn8, name: "Hulu" },
    { id: 17, image: chn17, name: "Paramount+" },
    { id: 18, image: chn18, name: "Rakuten TV" },
  ];

  const renderPoster = (item) => (
    <div className="group relative w-[150px] sm:w-[180px] md:w-[200px] lg:w-[220px] aspect-[2/3] rounded-card-md shadow-sm overflow-hidden border border-line">
      <img
        src={item.image}
        alt={item.name}
        loading="lazy"
        className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent"></div>
    </div>
  );

  return (
    <section className="section2" id="films" style={{backgroundColor: 'var(--bg-color)'}}>
      <div className="main-content">
        <Reveal className="mb-10">
          <SectionHeading eyebrow={c.eyebrow} title={c.title} align="center" />
        </Reveal>

        {/* Carrusel de películas — desplazamiento continuo */}
        <Reveal delay={100} className="mb-8">
          <p className="text-xs font-bold uppercase tracking-widest text-ink-muted mb-3">{c.filmsLabel}</p>
          <Marquee
            items={films}
            duration={48}
            renderItem={renderPoster}
          />
        </Reveal>

        {/* Carrusel de series — desplazamiento continuo */}
        <Reveal delay={125} className="mb-10">
          <p className="text-xs font-bold uppercase tracking-widest text-ink-muted mb-3">{c.seriesLabel}</p>
          <Marquee
            items={series}
            direction="right"
            duration={46}
            renderItem={renderPoster}
          />
        </Reveal>

        {/* Canales disponibles — desplazamiento continuo */}
        <Reveal delay={150} className="mb-8">
          <Marquee
            items={channels}
            direction="right"
            duration={38}
            renderItem={(channel) => (
              <div className="bg-white rounded-card-md border border-line px-6 py-4 shadow-sm w-40 sm:w-44 flex items-center justify-center h-16 md:h-20">
                <img
                  src={channel.image}
                  alt={channel.name}
                  loading="lazy"
                  className="max-w-full max-h-full object-contain opacity-90"
                />
              </div>
            )}
          />
        </Reveal>
      </div>
    </section>
  );
}
